export default __webpack_public_path__ + "static/media/Image4Mobile.688e3b7b.png";